import CustomAxios from '../../CustomAxios/CustomAxios';

export const updateUserAPI = (data:any) => {
  return CustomAxios.patch(`${process.env.REACT_APP_USERS_URL}/dev/users`, data);
}